<template>
  <div>
    <div
      class="grid w-full grid-cols-7 gap-4 px-3 py-2 bg-gray-100 rounded-lg pl"
      :class="{
        'border-red-600': !!error,
        'border-gray-100': !error,
      }"
    >
      <div class="text-main-primary">
        <FileUploadIcon />
      </div>
      <div class="col-span-5 font-medium text-gray-500 rounded-sm border-main-primary">
        <div class="overflow-hidden text-ellipsis no-localize-translate">
          {{ file.name }}
        </div>
        <div class="mt-0 text-sm">
          {{
            Number((file.size / 1024).toFixed(2)) > 1024
              ? (file.size / 1024 / 1024).toFixed(2) + "MB"
              : (file.size / 1024).toFixed(2) + "KB"
          }}
        </div>
      </div>
      <div class="flex justify-end">
        <button
          aria-label="Delete file"
          class="z-20 outline-none"
          type="button"
          @click="clearFormUpload"
        >
          <TimesSmall custom-style="text-slate-50 p-0.5 size-5 rounded-full bg-red-600" />
        </button>
      </div>
    </div>
    <div
      v-if="activeError.length"
      class="text-red-600"
    >
      {{ activeError.join(", ") }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'AttachmentListContainer',

  props: {
    file: {
      type: File,
      default: () => null,
    },
    fileUploadError: {
      type: String,
      default: '',
    },
    index: {
      type: Number,
      default: 0,
      required: true,
    },
    error: {
      type: Array,
      default: () => [],
    },
  },

  emits: ['delete'],

  computed: {
    activeError() {
      return this.error.filter(err => !!err)
    },
  },

  methods: {
    clearFormUpload() {
      this.$emit('delete', this.index)
    },
  },
}
</script>
